/*
 * @,@Author: ,: chenxupeng.cxp@bytedance.com
 * @,@LastEditors: ,: chenxupeng.cxp@bytedance.com
 */
import axios from 'axios';
import C_SHA1 from 'crypto-js/sha1';
import { getBrowser, filterKeyWords, sortObj } from './public';
// import store from '../store'
import Cookies from 'js-cookie';
// import { Loading, Message } from 'element-ui';
// let loading;
const isiPad = (navigator.userAgent.match(/(iPad)/) || (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1))
// 删除pad/ipad
let device =  /phone|pod|iPhone|iPod|ios|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone/i.test(navigator.userAgent)
device = device ? (isiPad ? false : true) : false

// 重写sha1验签返回算法
function c_sha1 (str) { return C_SHA1(str).toString() };
// function startLoading() {
//     loading = Loading.service({
//         lock: true,
//         text: 'Loading...',
//         background: 'rgba(0,0,0,0.6)',
//         spinner: 'el-icon-loading',
//         customClass: 'create-isLoading'
//     });
// }
// function endLoading() {
//     if (loading) {
//         loading.close();
//     }
// }
// 创建axios实例
const request = axios.create({
    baseURL: '/api', //请求接口域名
    timeout: 20000, // 请求超时设置
    withCredentials: false, //是否让axios请求携带 cookies 如果是用session验证此处为true 默认为false可以不写
    headers: {
        'content-type': 'application/json',
    }, //请求头配置
});



// 请求拦截
request.interceptors.request.use(
    (config) => {
        // send.json 不展示loading
        // if (config && config.url && config.url.includes('send.json')) {} else {
        //     startLoading();
        // }
        let browers = getBrowser();
        // 判断是否有deviceId
        const deviceId = localStorage.getItem('deviceId') || Cookies.get('deviceId') || '';
        const accessToken = Cookies.get('H5-access-token') ? Cookies.get('H5-access-token') : '';
        const TERM = !device ? '104' : '105';
        const VERSION = window['Plat_Version'];
        browers.type = filterKeyWords(browers.type);
        config.headers.wua = `GGirls/${VERSION} (WEB;${browers.type};${browers.versions};JA;${deviceId})`; // ZH-CN - 中文 JA - 日语
        config.headers.vi = `${VERSION};15;${TERM}`; // 104 PC端, 105 移动端
        if (config.params != undefined) {
            if (Object.keys(config.params).length === 0) {
                config.headers.st = Date.parse(new Date()) / 1000;
                const isStr = `st${config.headers.st}9b57f91496b7fb5f3c50bc06d95a7a32df273601`;
                config.headers.pp = c_sha1(isStr);
            } else {
                const timeStamp = Date.parse(new Date()) / 1000;
                config.headers.st = timeStamp;
                config.params.st = timeStamp;
                let sortObject = sortObj(config.params), strParam = '';
                for (let i in sortObject) {
                    strParam = strParam + `${i}${sortObject[i]}`;
                }
                strParam = strParam + '9b57f91496b7fb5f3c50bc06d95a7a32df273601';
                config.headers.pp = c_sha1(strParam);
            }
        } else {
            config.headers.st = Date.parse(new Date()) / 1000;
            const isStr = `st${config.headers.st}9b57f91496b7fb5f3c50bc06d95a7a32df273601`;
            config.headers.pp = c_sha1(isStr);

        }
        // accessToken
        if (accessToken) {
            config.headers.at = accessToken;
        }
        return config;
    },
    (error) => {
        return Promise.reject(error).catch(error => {
            // endLoading();
            return error
        });
    }
);


// 重试次数，共请求2次
axios.defaults.retry = 1

// 请求的间隙
axios.defaults.retryDelay = 1000

//响应拦截
request.interceptors.response.use(
    (response) => {
        //结束加载动画
        // endLoading();
        //此处判断token/ession是否过期然后跳转login页面 从新获取
        // if (response.data.code == -30) {
        //   router.push('/login')
        // }
        // const code = response.data.code;
        // 1212-token失效 登录判断
        // if (code != 0) {
        //     const msg = response.data.msg ? response.data.msg : '未知错误，请联系管理员。'
        //     // Message.error(msg);
        // }
        return response.data;
    },
    (error) => {
        // endLoading();
        let config = error.config;
        // 如果配置不存在或未设置重试选项，则拒绝
        if (!config || !config.retry) {
            return Promise.reject(error).catch(error => {
                console.warn('@@请求catch执行response-warn===', error)
                return error
            });
        }
        // 设置变量以跟踪重试次数
        config.__retryCount = config.__retryCount || 0;

        // 判断是否超过总重试次数
        if (config.__retryCount >= config.retry) {
            // 返回错误并退出自动重试
            return Promise.reject(error).catch(error => {
                console.warn('@@请求catch执行response-warn===', error)
                return error
            });
        }

        // 增加重试次数
        config.__retryCount += 1;

        // 创建新的Promise
        var backoff = new Promise(function(resolve) {
            setTimeout(function() {
                resolve();
            }, config.retryDelay || 1);
        });

        // 返回重试请求
        return backoff.then(function() {
            return axios(config);
        });
    }
);

export default request;
